import { parsePhoneNumberFromString } from "libphonenumber-js/max";

export interface PhoneInputAttributes {
    id?: string;
    name?: string;
    placeholder?: string;
    type?: string;
}

const PHONE_FIELD_TOKEN = /(?:^|[-_\s])(phone|mobile|telephone)(?:[-_\s]|$)/i;
const PHONE_FIELD_NAME = /^(phone|mobile|telephone)(?:[-_\s]?number)?$/i;
const LEGACY_PHONE_PLACEHOLDER = /^country\s+code\s*\+\s*number$/i;

export function isPhoneInputAttributes(
    attributes: PhoneInputAttributes
): boolean {
    if (attributes.type?.trim().toLowerCase() === "tel") {
        return true;
    }

    const identifiers = [attributes.id, attributes.name].filter(
        (value): value is string => Boolean(value)
    );
    if (
        identifiers.some((value) =>
            PHONE_FIELD_NAME.test(value.trim()) || PHONE_FIELD_TOKEN.test(value)
        )
    ) {
        return true;
    }

    const placeholder = attributes.placeholder?.trim() ?? "";
    return (
        PHONE_FIELD_TOKEN.test(placeholder) ||
        LEGACY_PHONE_PLACEHOLDER.test(placeholder)
    );
}

export function findRenderedPhoneInput(
    root: ParentNode = document
): HTMLInputElement | undefined {
    return Array.from(root.querySelectorAll<HTMLInputElement>("input")).find(
        (input) =>
            isPhoneInputAttributes({
                id: input.id,
                name: input.name,
                placeholder: input.placeholder,
                type: input.type,
            })
    );
}

export function normalizePhoneNumber(value: string): string | undefined {
    const parsedPhoneNumber = parsePhoneNumberFromString(value.trim(), {
        defaultCountry: "ZA",
        extract: false,
    });
    if (!parsedPhoneNumber?.isValid()) {
        return undefined;
    }

    if (/^(\d)\1+$/.test(parsedPhoneNumber.nationalNumber)) {
        return undefined;
    }

    return parsedPhoneNumber.number;
}
